import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@tryhackme/thm-ui-components';
import { StandardActionModal } from 'src/common/components/standard-action-modal';
import { StyledModalIcon } from 'src/common/components/standard-action-modal/standard-action-modal.styles';
import type { OptionsModalProps } from 'src/features/room/room.types';
import { StyledBody } from './instance-termination-modal.styles';
const iconComponent = <StyledModalIcon icon={faCircleExclamation} data-icon="error" />;
const handleThisPageButtonAction = () => {
  const url = 'https://help.tryhackme.com/en/articles/6498318-instance-termination';
  window.open(url, '_blank', 'noopener noreferrer');
};
const modalBodyText = <StyledBody>
    Unfortunately, your instance has been automatically terminated. Please re-start a new one. To learn more about why
    this happens, please refer to <span> </span>
    <Button variant="text" color="info" onClick={handleThisPageButtonAction}>
      this page
    </Button>
    .
  </StyledBody>;
export const InstanceTerminationModal = ({
  open,
  onOpenChange
}: Omit<OptionsModalProps, 'roomCode'>) => <StandardActionModal modalTitleText="Instance termination" modalBodyText={modalBodyText} dismissButtonTitle="Close" handleModalAction={() => {}} showIcon iconComponent={iconComponent} open={open} onOpenChange={onOpenChange} showActionButton={false} data-sentry-element="StandardActionModal" data-sentry-component="InstanceTerminationModal" data-sentry-source-file="instance-termination-modal.tsx" />;